import { Textarea } from '@/components/shadcn/ui/textarea';

import { useFieldContext } from './form';
import { getFieldError } from './get-field-error';

interface FormTextareaProps extends Omit<
  React.ComponentProps<typeof Textarea>,
  'value' | 'onChange' | 'name'
> {
  showErrorMessage?: boolean;
}

export function FormTextarea({
  showErrorMessage = true,
  ...textareaProps
}: FormTextareaProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Textarea
        id={field.name}
        name={field.name}
        value={field.state.value ?? ''}
        onChange={(e) => field.handleChange(e.target.value)}
        {...textareaProps}
      />
      {showErrorMessage && field.state.meta.errors.length > 0 && (
        <span className="text-destructive text-sm">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      )}
    </div>
  );
}
